import React from "react";
import { DEFAULT_SECTION } from "../../config";
import { withRouter } from "react-router-dom";

const viewObjectUrl = (id, section) =>
  `${process.env.REACT_APP_URL_PATH}/view/${id}/${section}`;

const _ObjectLink = ({ id, section, history, children, track, title }) => {
  const objectUrl = viewObjectUrl(id, section || DEFAULT_SECTION);
  return (
    <a
      href={objectUrl}
      title={title}
      onClick={e => {
        if (track) {
          window._$tarQ.push([
            "track",
            {
              datatype: "DATABASE",
              title: process.env.REACT_APP_PROJECT_NAME,
              itemtype: "RESULT_CLICK"
            }
          ]);
        }
        history.push(objectUrl);
        e.preventDefault();
      }}
    >
      {children}
    </a>
  );
};

const ObjectLink = withRouter(_ObjectLink);

export const TrackedObjectLink = ({ id, section, children, title }) => (
  <ObjectLink id={id} section={section} title={title} track>
    {children}
  </ObjectLink>
);

export default ObjectLink;
